import React, { useEffect } from 'react';
import PriceBlock from './PriceBlock';
import spinnerIcon from '../../img/spinner.svg';

function DriverForm(props) {
  const { sendAdditionalInfo, additionalData, step, addToDataLayer } = props;

  useEffect(() => {
    if (props.step === 3) {
      addToDataLayer('step3');
    }
  }, [step]);

  const submitHandler = (e) => {
    e.preventDefault();
    // window.gtag('event', 'click', { 'event_category': 'button2' });
    sendAdditionalInfo();
  }

  return (
    <div className={props.step === 3 ? 'kasco__kasco_calculation kasco_item show' : 'kasco__kasco_calculation kasco_item'}>
      <div className="item-head">
        <h2>{props.strings.title3} </h2>
      </div>
      <form onSubmit={(e) => submitHandler(e)} className={props.loading ? "pointer-events-none form_kasco__kasco_calculation form_kasco" : "form_kasco__kasco_calculation form_kasco"}>
        <div className="item-body">
          <PriceBlock
            strings={props.strings}
            marketPrice={props.marketPrice}
            marketPriceUah={props.marketPriceUah}
            isLoadingMarketPrice={props.isLoadingMarketPrice}
            carsData={props.carsData}
            showClientPriceOnly={true}
            clientPrice={props.clientPrice}
          />
          <div className="right-block">
            <div className="tab_check">
              <div className="mob-tit">{props.strings.dreiversCount}</div>
              <div className="form-check">
                <input onChange={props.setDriversCount} className="form-check-input" type="radio" name="radios" id="radio1" defaultValue="1" checked={additionalData.driversCont === 1} />
                <label className="form-check-label" htmlFor="radio1">
                  <span className="check-block" />
                  <p className="check-tit">
                    <i><svg width={23} height={26} viewBox="0 0 23 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path fillRule="evenodd" clipRule="evenodd" d="M19 25H4C3.20435 25 2.44129 24.6839 1.87868 24.1213C1.31607 23.5587 1 22.7956 1 22V19C1 17.35 5.701 16 11.5 16C17.299 16 22 17.35 22 19V22C22 22.7956 21.6839 23.5587 21.1213 24.1213C20.5587 24.6839 19.7956 25 19 25ZM11.5 11.5C8.1865 11.5 7 8.8135 7 5.5C7 2.1865 8.1865 1 11.5 1C14.8135 1 16 2.1865 16 5.5C16 8.8135 14.8135 11.5 11.5 11.5Z" stroke="#788392" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                    </i>                                                	<span>1 {props.strings.driver1}</span>
                  </p>
                </label>
              </div>
              <div className="form-check">
                <input onChange={props.setDriversCount} className="form-check-input" type="radio" name="radios" id="radio2" defaultValue="2" checked={additionalData.driversCont === 2} />
                <label className="form-check-label" htmlFor="radio2">
                  <span className="check-block" />
                  <p className="check-tit">
                    <i><svg width={40} height={26} viewBox="0 0 40 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path fillRule="evenodd" clipRule="evenodd" d="M19 25H4C3.20435 25 2.44129 24.6839 1.87868 24.1213C1.31607 23.5587 1 22.7956 1 22V19C1 17.35 5.701 16 11.5 16C17.299 16 22 17.35 22 19V22C22 22.7956 21.6839 23.5587 21.1213 24.1213C20.5587 24.6839 19.7956 25 19 25ZM11.5 11.5C8.1865 11.5 7 8.8135 7 5.5C7 2.1865 8.1865 1 11.5 1C14.8135 1 16 2.1865 16 5.5C16 8.8135 14.8135 11.5 11.5 11.5Z" stroke="white" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
                      <path d="M21.0004 25H36.0004C36.796 25 37.5591 24.6839 38.1217 24.1213C38.6843 23.5587 39.0004 22.7956 39.0004 22V19C39.0004 17.35 34.2994 16 28.5004 16C25.0692 16 22.0225 16.4726 20.1064 17.2003M28.5004 11.5C25.1869 11.5 24.0004 8.8135 24.0004 5.5C24.0004 2.1865 25.1869 1 28.5004 1C31.8139 1 33.0004 2.1865 33.0004 5.5C33.0004 8.8135 31.8139 11.5 28.5004 11.5Z" stroke="white" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                    </i>                                                	<span>2 {props.strings.driver2}</span>
                  </p>
                </label>
              </div>
              <div className="form-check">
                <input onChange={props.setDriversCount} className="form-check-input" type="radio" name="radios" id="radio3" defaultValue="3" checked={additionalData.driversCont === 3} />
                <label className="form-check-label" htmlFor="radio3">
                  <span className="check-block" />
                  <p className="check-tit">
                    <i><svg width={68} height={26} viewBox="0 0 68 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path fillRule="evenodd" clipRule="evenodd" d="M44 25H29C28.2044 25 27.4413 24.6839 26.8787 24.1213C26.3161 23.5587 26 22.7956 26 22V19C26 17.35 30.701 16 36.5 16C42.299 16 47 17.35 47 19V22C47 22.7956 46.6839 23.5587 46.1213 24.1213C45.5587 24.6839 44.7956 25 44 25ZM36.5 11.5C33.1865 11.5 32 8.8135 32 5.5C32 2.1865 33.1865 1 36.5 1C39.8135 1 41 2.1865 41 5.5C41 8.8135 39.8135 11.5 36.5 11.5Z" stroke="#788392" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
                      <path d="M27 25H12C11.2044 25 10.4413 24.6839 9.87868 24.1213C9.31607 23.5587 9 22.7956 9 22V19C9 17.35 13.701 16 19.5 16C22.8106 16 25.7633 16.44 27.6878 17.1246M19.5 11.5C16.1865 11.5 15 8.8135 15 5.5C15 2.1865 16.1865 1 19.5 1C22.8135 1 24 2.1865 24 5.5C24 8.8135 22.8135 11.5 19.5 11.5Z" stroke="#788392" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" /><path d="M46.0004 25H61.0004C61.796 25 62.5591 24.6839 63.1217 24.1213C63.6843 23.5587 64.0004 22.7956 64.0004 22V19C64.0004 17.35 59.2994 16 53.5004 16C50.0942 16 47.0668 16.4658 45.1484 17.1845M53.5004 11.5C50.1869 11.5 49.0004 8.8135 49.0004 5.5C49.0004 2.1865 50.1869 1 53.5004 1C56.8139 1 58.0004 2.1865 58.0004 5.5C58.0004 8.8135 56.8139 11.5 53.5004 11.5Z" stroke="#788392" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                    </i>
                    <span>3 {props.strings.driver2}</span>
                  </p>
                </label>
              </div>
              <div className="form-check">
                <input onChange={props.setDriversCount} className="form-check-input" type="radio" name="radios" id="radio4" defaultValue="4" checked={additionalData.driversCont === 4} />
                <label className="form-check-label" htmlFor="radio4">
                  <span className="check-block" />
                  <p className="check-tit">
                    <i><svg width={23} height={26} viewBox="0 0 23 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path fillRule="evenodd" clipRule="evenodd" d="M19 25H4C3.20435 25 2.44129 24.6839 1.87868 24.1213C1.31607 23.5587 1 22.7956 1 22V19C1 17.35 5.701 16 11.5 16C17.299 16 22 17.35 22 19V22C22 22.7956 21.6839 23.5587 21.1213 24.1213C20.5587 24.6839 19.7956 25 19 25ZM11.5 11.5C8.1865 11.5 7 8.8135 7 5.5C7 2.1865 8.1865 1 11.5 1C14.8135 1 16 2.1865 16 5.5C16 8.8135 14.8135 11.5 11.5 11.5Z" stroke="#788392" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                      <svg width={10} height={10} viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5 1V9" stroke="#788392" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" /><path d="M9 5L1 5" stroke="#788392" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" /></svg>
                    </i>                                                	<span>{props.strings.without}</span>
                  </p>
                </label>
              </div>
            </div>{/* tab_check */}
            {/*<div className="form-inline">*/}
            {/*  <div className={(props.hasError && additionalData.age < 18 || additionalData.age > 99) ? 'form-group val-gr group-inval age-f validation-error' : 'form-group val-gr group-inval age-f'}>*/}
            {/*    <label>{props.strings.age1}*</label>*/}
            {/*    <input */}
            {/*      onChange={props.handleAdditionalInputs} */}
            {/*      type="number"*/}
            {/*      min="1" */}
            {/*      name="age" */}
            {/*      className="form-control age" */}
            {/*      placeholder={props.strings.age3} value={additionalData.age} />*/}
            {/*    <div className="validation">{props.strings.age2}</div>*/}
            {/*  </div>*/}
            {/*  <div className={(props.hasError && additionalData.experience < 1 || additionalData.experience > 99) ? 'form-group val-gr group-inval experience-f validation-error' : 'form-group val-gr group-inval experience-f'}>*/}
            {/*    <label>{props.strings.exp1}*</label>*/}
            {/*    <input onChange={props.handleAdditionalInputs} type="number" min="1" name="experience" className="form-control experience" placeholder={props.strings.exp3} value={additionalData.experience} />*/}
            {/*    <div className="validation">{props.strings.exp2}</div>*/}
            {/*  </div>*/}
            {/*</div>/!* form-inline *!/*/}
            <div className="form-inline">
              <div className="form-group form-select without-search">
                <label>{props.strings.age1}</label>
                <select
                  onChange={props.handleAdditionalInputs}
                  // title={props.strings.selectTitle}
                  className="selectpicker"
                  name="age"
                  value={additionalData.age}
                >
                  {props.agesOptions}
                  <option value=">30">{props.strings.age2}</option>
                </select>
              </div>
              <div className="form-group form-select without-search">
                <label>{props.strings.exp1}</label>
                <select
                  onChange={props.handleAdditionalInputs}
                  // title={props.strings.selectTitle}
                  className="selectpicker"
                  name="experience"
                  value={additionalData.experience}
                >
                  {props.expOptions}
                  <option value=">10">{props.strings.exp2}</option>
                </select>
              </div>
            </div>{/* form-inline */}
            <div className="form-inline">
              <div className="form-group form-select without-search">
                <label>{props.strings.taxi}</label>
                <select onChange={props.handleAdditionalInputs} title={props.strings.selectTitle} className="selectpicker" name="taxi" value={additionalData.taxi ? additionalData.taxi : 'false'}>
                  <option value={false}>{props.strings.no}</option>
                  <option value>{props.strings.yes}</option>
                </select>
              </div>
              <div className="form-group form-select without-search">
                <label>{props.strings.credit}</label>
                <select onChange={props.handleAdditionalInputs} title={props.strings.selectTitle} className="selectpicker" name="credit" value={additionalData.credit ? additionalData.credit : 'false'}>
                  <option value={false}>{props.strings.no}</option>
                  <option value>{props.strings.yes}</option>
                </select>
              </div>
            </div>{/* form-inline */}
          </div>{/* right-block */}
        </div>
        <div className="item-footer">
          <div className={props.loading ? "btn btn-back btn-disabled disabled" : "btn btn-back"} onClick={props.prevStep}><div data-id="not_found">
            <svg width={6} height={10} viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5 9L1 5L5 1" stroke="#788392" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" /></svg>{props.strings.back}
          </div></div>
          {props.loading ?
            <div className="btn-valid"><img src={spinnerIcon} alt="loading" /></div>
            :
            <div className={props.loading ? 'btn-valid btn-disabled disabled' : 'btn-valid'}>
              <button className="btn btn-bg btn-next" disabled={props.loading}>
                <div data-id="kasco_calculation">{props.strings.find}</div>
              </button>
            </div>
          }
        </div>
      </form>
    </div>
  );
}

export default DriverForm;
